import { gql } from "@apollo/client";
import { lensDetailsConnectionFragment } from "../fragments";
import { lensCompoundIdFragment } from "../fragments/lensCompoundIdFragment";

export const getLensV2 = gql`
    query getLensV2($lensCompoundId: InputLensCompoundId, $organizationId: String = null) {
        getLensV2(input: { organizationId: $organizationId, lensCompoundId: $lensCompoundId }) {
            connections {
                ...LensDetailsConnection
            }
            lens {
                name
                vendorData {
                    key
                    value
                }
                previewUrl
                iconUrl
                videoUrl
                previewWebpUrl
                updatedAt {
                    seconds
                }
                hasMusic
                lensSourceInfo {
                    name
                }
                ...LensCompoundId
            }
        }
    }
    ${lensDetailsConnectionFragment}
    ${lensCompoundIdFragment}
`;
